import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import createSubjectWithoutProductResolving from './createSubjectWithoutProductResolving';
export default function createSubject(_x, _x2) {
  return _createSubject.apply(this, arguments);
}

function _createSubject() {
  _createSubject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx, partial) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (ctx || {
              resolveProduct: function resolveProduct(p) {
                return Promise.resolve(p);
              }
            }).resolveProduct((partial || {}).product).then(function (resolvedProduct) {
              return _extends({}, partial || {}, {
                product: resolvedProduct
              });
            }).then(createSubjectWithoutProductResolving));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createSubject.apply(this, arguments);
}